import { useQueryStates, parseAsString } from 'nuqs'

export const useFieldglassJobPostingFiltersQueryState = () => {
  return useQueryStates(
    {
      jobPostingId: parseAsString,
    },
    {
      urlKeys: {
        jobPostingId: 'job-posting-id',
      },
    }
  )
}
